import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { GoogleAuthProvider, OAuthProvider, getAuth } from 'firebase/auth';

console.log('kkk :', process.env.REACT_APP_FIREBASE_API_KEY);

// Initialize Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const google = new GoogleAuthProvider();
const apple = new OAuthProvider('apple.com');
// Increase the timeout duration
// auth.settings.appVerificationDisabledForTesting = true;
// auth.settings.timeout = 60000;

const db = getFirestore(app);

export { auth, google, apple, db };
